export default {
    openMenu: 'Menú Abierto',
};
